var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:[
    this.isMobile ? 'mobile' : '',
    this.isLandscape ? 'landscape' : '',
    'app-container' ]},[_c('div',{staticClass:"rotate-portrait"},[_c('v-icon',{attrs:{"color":"blue","width":"100%","height":"100%"}},[_vm._v("mdi-phone-rotate-portrait")]),_c('span',{staticClass:"please-rotate"},[_vm._v("Please rotate your device to portrait mode!")])],1),_c('Main')],1)}
var staticRenderFns = []

export { render, staticRenderFns }